import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateService } from 'angular-ui-router';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';

interface IPageDo0068 extends IComponentController {
    oftMultiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    criteresSuggeres: any;
}
 interface IDo0068Params {
     menuId: string
     unocleint: number
     trmcleint: number
     ofacleint: number
     unocleintrh: number
 }

/* @ngInject */
export default function Do0068Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    do0064Route: IRoute,
    do0069Route: IRoute,
    do0065Route: IRoute,
    gs2005Route: IRoute,
    rr0073Route: IRoute,
    rr0074Route: IRoute,
    mr2006Route: IRoute,
    rr0076Route: IRoute,
    $state: IStateService,
    MenuItemEcran: IMenuItemEcranClass,
    $stateParams: IDo0068Params,
    MenuItemAction: IMenuItemActionClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass
) {
   const vm: IPageDo0068 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        noId: true
    };

    const criteresSuggeres = new Formulaire([
        new FormulaireItem('unocleint', {
            largeur: 33, required: true, default: $stateParams.unocleint
        }),
        new FormulaireItem('trmcleint', {
            largeur: 33, required: true, default: $stateParams.trmcleint
        }),
        new FormulaireItem('radio_can', {
            largeur: 33
        }),
        new FormulaireItem('temcleint', {
            largeur: 33
        }),
        new FormulaireItem('litcleint', {
            largeur: 33
        }),
        new FormulaireItem('crscleint', {
            largeur: 33,
            resourceParams: (data: any) => {
                return {
                    unocleint: data.unocleint,
                    trmcleint: data.trmcleint
                };
            }
        }),
        new FormulaireItemSautDeLigne(),
        new FormulaireItem('radio_aff', {
            largeur: 33
        }),
        new FormulaireItem('radio_emp', {
            largeur: 33
        }),
        new FormulaireItem('flgderoff', {
            largeur: 33
        }),
        new FormulaireItem('flgcriava', {
            largeur: 50
        })
    ], { largeurDefaut: 30 })


    vm.oftMultiOccurrenceOptions = {
        bloc: 'oft',
        criteresSuggeres: criteresSuggeres,
        fonctions: {
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: !vm.valeursEcran.isforage,
            criteresSuggeresVisibles: !vm.valeursEcran.isforage,
            effaceCriteres: true
        },
        colonnesFixesGauche: [
            { nom: 'ofanum', largeur: 155, changeColor: true, menu: [
                    new MenuItemForage(
                        'LBL_EMPLOIS',
                        do0064Route.NAME,
                        (rowData: any) => ({
                            ofacleint: rowData.ofacleint,
                            isforage: 1,
                            trmcleint: rowData.trmcleintcri,
                            unocleintrh: rowData.unocleintrhcri,
                        }),
                    )
                ]
            },
            { nom: 'crscod', largeur: 130, changeColor: true },
            { nom: 'crsdsc', largeur: 220, changeColor: true }],
        colonnesVisibles: [
            { nom: 'temcod', largeur: 130, hidden: (rowData: any) => rowData.ciaflgcachetem, changeColor: true },
            { nom: 'temdsc', largeur: 130, hidden: (rowData: any) => rowData.ciaflgcachetem, changeColor: true },
            { nom: 'cofgrp', largeur: 75,  changeColor: true },
            { nom: 'ofadatdeb', largeur: 130, hidden: (rowData: any) => rowData.ciaflgcachetem, changeColor: true },
            { nom: 'ofadatfin', largeur: 130, hidden: (rowData: any) => rowData.ciaflgcachetem, changeColor: true },
            { nom: 'ofanbrcan', largeur: 80, changeColor: true },
            { nom: 'oftnbrsel', largeur: 85, changeColor: true },
            { nom: 'sold_crs', largeur: 120, hidden: (rowData: any) => rowData.ciaflgaffbqe, changeColor: true },
            { nom: 'sold_global', largeur: 120, hidden: (rowData: any) => rowData.ciaflgaffbqe, changeColor: true },
            { nom: 'caenom', largeur: 140, changeColor: true },
            { nom: 'caeprn', largeur: 140, changeColor: true },
            { nom: 'caenummat', largeur: 140, changeColor: true },
            {
                nom: 'caecomcan', largeur: 250, changeColor: true, menu: [
                    new MenuItemForage(
                        'LBL_EMPLOIS',
                        do0065Route.NAME,
                        (rowData: any) => ({
                            id: rowData.caecleint
                        }),
                    ),
                    new MenuItemEcran(
                        'LBL_attachement',
                        gs2005Route.NAME,
                        (data: any) => ({
                            id: data.caecleint,
                            pjbprvcle: 'CAE',
                            pjbcleintref: data.caecleint
                        }),
                        {
                            icon: 'attach_file',
                            compteur: (data: any) => data.nbpij === 0 ? undefined : data.nbpij
                        }
                    ),
                ]
            },
            { nom: 'oftflgautemp', largeur: 130, changeColor: true,
                menu: [
                    new MenuItemForage(
                        'LBL_EMPLOIS',
                        do0069Route.NAME,
                        (rowData: any) => ({
                            caecleint: rowData.caecleint,
                            ofacleint: rowData.ofacleint,
                            eplcleint: rowData.eplcleint,
                            eplnummat: rowData.eplnummat,
                            ofadatdeb: rowData.ofadatdeb,
                            ofadatfin: rowData.ofadatfin
                        }),
                        {disabled: (rowData: any) => !rowData.oftflgautemp}
                    )
                ]
             },
            { nom: 'ofcflgrej', largeur: 140, changeColor: true },
            { nom: 'ofcflgsel', largeur: 150, changeColor: true},
            { nom: 'ofcflgcou', largeur: 140, hidden: true},

            { nom: 'ofcflgdes', largeur: 140, changeColor: true },
            { nom: 'ofcdatdes', largeur: 140, changeColor: true },
            {
                nom: 'caecom', largeur: 200, changeColor: true, menu: [
                    new MenuItemAction(
                        'LBL_DER',
                        'BOU_REPETU',
                        (rowData: any) => ({
                                    stamnetab: 'OFC',
                                    codperm: rowData.codperm,
                                    datdem: rowData.ofadatdeb,
                                    cleintref: rowData.ofccleint,
                                    datfin: rowData.datfin,
                                    dmecleint: rowData.dmecleint,
                                    caecleint: rowData.caecleint,
                                    ofacleint: rowData.ofacleint,
                                    temcleint: rowData.temcleint,
                                    eplcleint: rowData.eplcleint,
                                    nas: rowData.nas,
                                    flgimm: rowData.flgimm,
                                    datexp: rowData.datexp
                        }),
                        {
                            icon: 'accessibility_new',
                            fonction: 'BTN_DEM',
                            iconColor: 'orange',
                            successAction: (rowData: any) => {
                                const mr2006Link = $state.href(mr2006Route.NAME, {id: rowData.et2cleint , stamnetab: 'OFC', menuId: $stateParams.menuId });
                                if (mr2006Link) {
                                   window.open(mr2006Link, '_blank');
                                }
                                }
                            }
                    ),
                ]
            },
            { nom: 'eplnummat', largeur: 130, changeColor: true },
            {
                nom: 'ofcflgdemepl', largeur: 130, changeColor: true, menu: [
                    new MenuItemAction(
                        'LBL_DER',
                        'BOUDME',
                        (rowData:any) => ({ demcleint: rowData.demcleintref , 
                            dmecleint:rowData.dmecleint,
                            eplcleint: rowData.eplcleint,
                            ofcflgsel: rowData.ofcflgsel,
                            ofcflgdemepl: rowData.ofcflgdemepl,
                            caecleint: rowData.caecleint
                        }),
                        {
                            icon: 'add_notes',
                            fonction: 'BTN_BOUDME',
                            saveFirst: true,
                            successAction: (retour: any) => {
                                const rr0076Link = $state.href(rr0076Route.NAME,{id:retour.dmecleintnew , stamnetab: 'CAE', cleintref: retour.caecleint, menuId: $stateParams.menuId});
                                if (rr0076Link) {
                                   window.open(rr0076Link, '_blank');
                                }
                            }
                        }
                    ),
                    new MenuItemAction(
                        'LBL_DER',
                        'BOUAJTDEM',
                        (rowData:any) => ({ demcleint: rowData.demcleintref , 
                            ofcflgsel: rowData.ofcflgsel,
                            dmecleint: rowData.dmecleint,
                            ofadatdeb: rowData.ofadatdeb,
                            ofadatfin: rowData.ofadatfin,
                            eplcleint: rowData.eplcleint,
                            caecleint: rowData.caecleint,
                            eplnummat: rowData.eplnummat
                        }),
                        {
                            icon: 'add_notes',
                            fonction: 'BTN_BOUAJTDEM',
                            saveFirst: true
                        }
                    ),
                ]
            },
            { nom: 'lemcod', largeur: 130, changeColor: true },
            {
                nom: 'lemdsc', largeur: 130, changeColor: true, menu: [
                    new MenuItemAction(
                        'LBL_LEM',
                        'BOULEM',
                        () => ({}),
                        {
                            icon: 'add_notes',
                        },
                    ),
                ]
            },
            {
                nom: 'dernumdoc', largeur: 150, changeColor: true, menu: [
                    new MenuItemAction(
                        'LBL_DER',
                        'BOUDER',
                        (rowData:any) => ({
                            trmcleint: rowData.trmcleint,
                            unocleint: rowData.unocleint,
                            demcleint: rowData.demcleintref,
                            temcleint: rowData.temcleint,
                            tdgcleint: rowData.tdgcleint,
                            ofadatdeb: rowData.ofadatdeb,
                            ofadatfin: rowData.ofadatfin,
                            ofcflgsel: rowData.ofcflgsel,
                            lemcleint: rowData.lemcleint,
                            poscleintsup: rowData.poscleintsup,
                            intcleintref: rowData.intcleintref,
                            respsupervision: rowData.respsupervision
                        }),
                        {
                            //icon: 'add_notes',
                            icon: 'add',
                            fonction: 'BOUDER',
                            formulaireConfirmationAction: {
                                lblTitre: 'LBL_DEMANDE', 
                                largeurFormulaire: 35,
                                formulaire: new Formulaire([
                                    new FormulaireItem('title',{
                                         titre: vm.valeursEcran.tdm_title,
                                         hidden:(rowData: any)=> !rowData.dercleint,
                                         readonly: true
                                    }) ,
                                    new FormulaireItem('tdmcleint', { required : true,
                                         resourceParams: (rowData: any) => ({ temcleint: rowData.temcleint }),
                                    }) ,

                                    new FormulaireItem('tdgcleint', { required: true,
                                        resourceParams: (rowData: any) => ({ tdmcleint2: rowData.tdmcleint })
                                    }),
                                    new FormulaireItem('poscleintsup', { hidden: (rowData: any) => rowData.tdmflgpossup === 0,
                                                                         required: (rowData: any) => rowData.tdmflgpossup
                                    }),
                                    new FormulaireItem('resp_supervision', { hidden: (rowData: any) => rowData.tdmflgintref === 0,
                                                                             readonly: true
                                    }),
                                    new FormulaireItem('intcleintref2', { hidden: (rowData: any) => rowData.tdmflgintref2 === 0,
                                                                          required: (rowData: any) => rowData.tdmflgintref2 !== 0
                                    })
                                ], { largeurDefaut: 100 })
                            },
                            successAction: (retour:any) => { 
                               const rr0074Link = $state.href(rr0074Route.NAME,{id:retour.trncleintref , menuId: $stateParams.menuId});
                               if (rr0074Link) {
                                   window.open(rr0074Link, '_blank');
                               }
                            }
                        }
                    )
                ]
            },
            {
                nom: 'ecldsceta', largeur: 130, changeColor: true, menu: [
                    new MenuItemForage(
                        'LBL_EMPLOIS',
                        rr0074Route.NAME,
                        (rowData: any) => ({
                            id: rowData.trncleintref
                        })
                    )
                ]
            },
            {
                nom: 'oftflgdermul', largeur: 70, changeColor: true, menu: [
                    new MenuItemForage(
                        'LBL_EMPLOIS',
                        rr0073Route.NAME,
                        (rowData: any) => ({
                            demcleint: rowData.demcleintref,
                            temcleint: rowData.temcleint,
                            unocleint: rowData.unocleintcri,
                            efface_criteres: true
                        }),
                    )
                ]
            },
            { nom: 'caeadrcou', largeur: 250, changeColor: true, hidden: false },
        ],
        formulaire: new Formulaire([
            new FormulaireItem('eplcleint', { largeur: 33,
                    readonly: (rowData:any) => !(rowData.flgmodifallowed),
                    default:  (rowData: any) => (rowData.eplcleint__eplnummat, rowData.eplcleint__eplprn, rowData.eplcleint__eplnom),
                    resourceParams: (rowData: any) => (
                        {
                            eplcleint: rowData.eplcleint,
                        })
             }),
            new FormulaireItem('ecldsceta', { readonly: true, largeur: 33 }),
            new FormulaireItem('lemcleint', {
                largeur: 33,
                readonly: (rowData:any) => !(rowData.flgmodifallowed),
                default: (rowData: any) => (rowData.lemcleint__lemcod, rowData.lemcleint__tlecod, rowData.lemcleint__tledsc),
                resourceParams: (rowData: any) => (
                    {
                        demcleintref: rowData.demcleintref,
                        urgcleint: rowData.urgcleint,
                        ofadatdeb: rowData.ofadatdeb,
                        ofadatfin: rowData.ofadatfin,
                        temcleint: rowData.temcleint                       
                    })
            }),
            new FormulaireItem('ofcflgrej', {
                largeur: 33, readonly: (rowData:any) => !(rowData.flgmodifallowed)
            }),
            new FormulaireItem('ofcflgsel', {
                largeur: 33, readonly: (rowData:any) => !(rowData.flgmodifallowed) }
            ),
            new FormulaireItem('ofcflgcou', {
                largeur: 33, readonly: (rowData:any) => (rowData.flgro_ofcflgcou), hidden: (rowData:any) => !(rowData.flgetaselexists) }
            ),
            new FormulaireItem('caeadrcou', {
                largeur: 33, readonly: true, hidden: (rowData:any) => !(rowData.flgetaselexists) }
            ),
            new FormulaireItem('ofcdatdes', {
                readonly: true,
                largeur: 33
            }),
            new FormulaireItem('caecomcan', { largeur: 33, readonly: true }),  // Commentaire
            new FormulaireItem('caecom', { largeur: 33, readonly: (rowData:any) => !(rowData.flgmodifallowed) }),  // Commentaire interne
        ]),
        colonnesCachees: [
            'ciecleint',
            'ofacleint',
            'title_disp',
            'disp_email', 
            'color',
            'run_dem', 
            'caecleint', 
            'ofccleint', 
            'dercleint', 
            'codperm', 
            'nas', 
            'flgimm', 
            'datexp', 
            'disab_aux', 
            'disab_emp', 
            'ciaflgcachetem', 
            'ciaflgaffbqe', 
            'dmecleint', 
            'usrnom',
            'demcleintref',
            'temcleint',
            'trncleintref',
            'eplcleint', 
            'ofadatdeb', 
            'ofadatfin', 
            'trmcleint',
            'unocleint',
            'lemcleint',
            'flgvidchalemcleint',
            'demcleint',
            'flgcom',
            'flgmodifallowed',
            'trmcleintcri',
            'unocleintrhcri',
            'flgdosempann',
            'nbrtypdemrem',
            'unocleintcri',
            'tagcleint',
            'flgetaselexists',
            'tdmflgpossup',
            'tdmflgintref',
            'resp_supervision',
            'tdmflgintref2',
            'nbpij'
        ]
    }
}
